(function () {
  const $ = (sel, root = document) => root.querySelector(sel);

  const els = {
    drawer: $("#cst-drawer"),
    items: $("#cst-drawer-items"),

    subtotalMirror: $("#cst-drawer [data-cst-subtotal]"),
    count: $("#cst-drawer [data-cst-count]"),

    addForm: $("#cst-cart-add-form"),
    checkoutBtn: $("#cst-checkout-btn"),
    insuranceWrap: $("#cst-insurance"),
    upsellWrap: $("#cst-upsell"),
    upsellEmpty: $("#cst-upsell-empty"),

    empty: $("#cst-empty"),
    pinned: $("#cst-pinned"),
    footer: $("#cst-footer"),
    sections: Array.from(document.querySelectorAll("#cst-drawer [data-cst-section]")),
    headerItemCount: document.querySelector(".item_count_el"),
  };

  if (!els.drawer) return;

  const parseIds = (csv) =>
    (csv || "")
      .split(",")
      .map((x) => Number(String(x).trim()))
      .filter(Boolean);

  const drawerData = els.drawer?.dataset || {};

  // warranty_product (extended-warranty) dinamik
  const WARRANTY = {
    handle: (drawerData.warrantyHandle || "").trim(),
    productId: Number(drawerData.warrantyProductId || 0) || 0,
    variantIds: parseIds(drawerData.warrantyVariantIds),
  };

  // insurance_product (merchandise-shipping-insurance) dinamik (tüm variantlar)
  const INSURANCE = {
    handle: (drawerData.insuranceHandle || "").trim(),
    productId: Number(drawerData.insuranceProductId || 0) || 0,
    variantIds: parseIds(drawerData.insuranceVariantIds),
  };

  const INS_OPT_OUT_KEY = "cst_insurance_optout";

  const state = {
    isOpen: false,
    currency: "USD",
    lastCart: null,
    queue: Promise.resolve(),
    isPruningInsuranceOnly: false,
  };

  const esc = (s) =>
    (s || "").toString().replace(/[&<>"']/g, (c) => {
      const map = { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" };
      return map[c] || c;
    });

  const formatMoney = (cents, currency) => {
    const cur = currency || state.currency || "USD";
    try {
      return new Intl.NumberFormat(undefined, { style: "currency", currency: cur }).format((cents || 0) / 100);
    } catch {
      return `${(cents || 0) / 100}`;
    }
  };

  const enqueue = (fn) => {
    state.queue = state.queue
      .then(() => fn())
      .catch((err) => {
        console.error("[cst] op failed:", err);
        throw err;
      });
    return state.queue;
  };

  const setBtnLoading = (btn, loading) => {
    if (!btn) return;
    btn.disabled = !!loading;
    btn.classList.toggle("is-loading", !!loading);
    btn.dataset.loading = loading ? "1" : "0";
  };

  const setLineLoading = (line, loading) => {
    if (!els.items) return;
    const row = els.items.querySelector(`.cst-item__parent[data-line="${Number(line)}"]`);
    if (!row) return;
    row.classList.toggle("is-loading", !!loading);
  };

  const open = () => {
    els.drawer.hidden = false;
    document.documentElement.classList.add("cst-open");
    state.isOpen = true;
  };

  const close = () => {
    document.documentElement.classList.remove("cst-open");
    els.drawer.hidden = true;
    state.isOpen = false;
  };

  document.addEventListener("click", (e) => {
    if (e.target.closest("[data-cst-close]")) close();
  });

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && state.isOpen) close();
  });

  if (els.checkoutBtn) {
    els.checkoutBtn.addEventListener("click", () => {
      setBtnLoading(els.checkoutBtn, true);
      window.location.href = "/checkout";
    });
  }

  const fetchCart = async () => {
    const res = await fetch("/cart.js", { headers: { Accept: "application/json" } });
    if (!res.ok) throw new Error("Cart fetch failed");
    const cart = await res.json();
    state.lastCart = cart;
    state.currency = cart?.currency || state.currency;
    return cart;
  };

  const postJson = async (url, payload) => {
    const res = await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(payload),
    });

    if (!res.ok) {
      let msg = "Request failed";
      try {
        const j = await res.json();
        msg = j?.description || j?.message || msg;
      } catch {
        msg = await res.text();
      }
      throw new Error(msg);
    }
    return res.json();
  };

  const addViaFormData = async ({ id, quantity = 1, properties = null }) => {
    if (!els.addForm) throw new Error("cst-cart-add-form not found");

    const idInput = $('input[name="id"]', els.addForm);
    const qtyInput = $('input[name="quantity"]', els.addForm);
    if (!idInput) throw new Error("add form input[name=id] missing");

    els.addForm.querySelectorAll('input[name^="properties["]').forEach((n) => n.remove());

    idInput.value = String(id);
    if (qtyInput) qtyInput.value = String(quantity);

    if (properties && typeof properties === "object") {
      Object.entries(properties).forEach(([k, v]) => {
        const inp = document.createElement("input");
        inp.type = "hidden";
        inp.name = `properties[${k}]`;
        inp.value = String(v ?? "");
        els.addForm.appendChild(inp);
      });
    }

    const fd = new FormData(els.addForm);
    const res = await fetch("/cart/add.js", { method: "POST", headers: { Accept: "application/json" }, body: fd });

    if (!res.ok) {
      let msg = "Add to cart failed";
      try {
        const j = await res.json();
        msg = j?.description || j?.message || msg;
      } catch {
        msg = await res.text();
      }
      throw new Error(msg);
    }

    return res.json();
  };

  const isInsuranceOptedOut = () => {
    try {
      return localStorage.getItem(INS_OPT_OUT_KEY) === "1";
    } catch {
      return false;
    }
  };

  const setInsuranceOptedOut = (val) => {
    try {
      if (val) localStorage.setItem(INS_OPT_OUT_KEY, "1");
      else localStorage.removeItem(INS_OPT_OUT_KEY);
    } catch {}
  };

  const getInsuranceVariantId = () => {
    const raw = els.insuranceWrap?.dataset?.insuranceVariantId || "";
    return Number(raw || 0) || 0;
  };

  const cartHasVariant = (cart, variantId) =>
    !!cart?.items?.some((it) => Number(it.id) === Number(variantId));

  const cartHasAnyVariant = (cart, ids) =>
    !!cart?.items?.some((it) => (ids || []).includes(Number(it.id)));

  const findLineByVariant = (cart, variantId) => {
    if (!cart?.items?.length) return 0;
    const idx = cart.items.findIndex((it) => Number(it.id) === Number(variantId));
    return idx >= 0 ? idx + 1 : 0;
  };

  const renderProperties = (props) => {
    if (!props || typeof props !== "object") return "";
    const entries = Object.entries(props)
      .filter(([k, v]) => {
        const key = (k || "").toString();
        const val = v == null ? "" : String(v);
        if (!key) return false;
        if (key.startsWith("_")) return false;
        if (!val.trim()) return false;
        return true;
      })
      .slice(0, 10);

    if (!entries.length) return "";
    return `
      <div class="cst-props">
        ${entries.map(([k, v]) => `<div class="cst-prop"><span>${esc(k)}:</span> ${esc(String(v))}</div>`).join("")}
      </div>
    `;
  };

  const syncInsuranceToggle = (cart) => {
    if (!els.insuranceWrap) return;
    const btn = els.insuranceWrap.querySelector("[data-cst-ins-toggle]");
    if (!btn) return;

    const insId = getInsuranceVariantId();
    if (!insId) return;

    const has = cartHasVariant(cart, insId);
    btn.setAttribute("aria-pressed", has ? "true" : "false");
    btn.classList.toggle("is-on", has);
  };

const syncUpsellVisibility = (cart) => {
  if (!els.upsellWrap) return;

  const cards = Array.from(els.upsellWrap.querySelectorAll("[data-cst-upsell-card]"));
  if (!cards.length) return;

  const warrantyIds = (WARRANTY.variantIds || []).map(Number).filter(Boolean);
  const warrantyPid = Number(WARRANTY.productId || 0) || 0;
  const warrantyHandle = (WARRANTY.handle || "extended-warranty").trim();

  // Sepette warranty var mı?
  const shouldHideWarranty = !!cart?.items?.some((it) => {
    const vidA = Number(it?.id || 0);
    const vidB = Number(it?.variant_id || 0);
    const pid = Number(it?.product_id || 0);
    const h1 = (it?.handle || "").trim();
    const h2 = (it?.product_handle || "").trim();

    return (
      (warrantyIds.length && (warrantyIds.includes(vidA) || warrantyIds.includes(vidB))) ||
      (warrantyPid && pid === warrantyPid) ||
      (warrantyHandle && (h1 === warrantyHandle || h2 === warrantyHandle))
    );
  });

  cards.forEach((card) => {
    const handle = (card.dataset.handle || "").trim();
    const pid = Number(card.dataset.productId || 0);

    const isWarrantyCard =
      (warrantyHandle && handle === warrantyHandle) ||
      (warrantyPid && pid === warrantyPid) ||
      handle === "extended-warranty";

    const hide = isWarrantyCard && shouldHideWarranty;

    
    card.hidden = hide;
    card.style.display = hide ? "none" : "";
    card.classList.toggle("is-hidden-by-cart", hide);
    card.setAttribute("aria-hidden", hide ? "true" : "false");
  });

  const visibleCount = cards.filter((c) => c.style.display !== "none" && !c.hidden).length;
  if (els.upsellEmpty) els.upsellEmpty.hidden = visibleCount !== 0;
};



const setCountLabel = (count) => {
  const wrap = els.drawer?.querySelector(".cst__count");
  if (!wrap) return;

  const span = wrap.querySelector("[data-cst-count]");
  if (!span) return;

  const nodes = Array.from(wrap.childNodes);
  const spanIndex = nodes.indexOf(span);

  const textNode = nodes.slice(spanIndex + 1).find((n) => n.nodeType === Node.TEXT_NODE);
  if (!textNode) return;

  const word = Number(count) === 1 ? " item" : " items";
  textNode.nodeValue = textNode.nodeValue.replace(/\sitems|\sitem/g, word);
};

const pruneInsuranceIfOnlyItemLeft = async (cart) => {
  if (!cart?.items?.length) return false;
  if (state.isPruningInsuranceOnly) return false;

  const insuranceIds = (INSURANCE.variantIds || []).map(Number).filter(Boolean);

  const nonInsQty = (cart.items || [])
    .filter((it) => !insuranceIds.includes(Number(it.id || 0)))
    .reduce((sum, it) => sum + Number(it.quantity || 0), 0);

  if (nonInsQty > 0) return false;

  const linesToRemove = (cart.items || [])
    .map((it, idx) => ({ it, line: idx + 1 }))
    .filter(({ it }) => insuranceIds.includes(Number(it.id || 0)))
    .map(({ line }) => line);

  if (!linesToRemove.length) return false;

  state.isPruningInsuranceOnly = true;
  try {
    setInsuranceOptedOut(true);

    for (const line of linesToRemove) {
      await postJson("/cart/change.js", { line, quantity: 0 });
    }

    return true;
  } finally {
    state.isPruningInsuranceOnly = false;
  }
};


  const renderCart = (cart) => {




    const currency = cart?.currency || state.currency || "USD";
    state.currency = currency;

    if (!els.items) return;

    
    const insuranceIds = INSURANCE.variantIds || [];

    const visibleItems = (cart.items || []).filter((it) => {
      const vid = Number(it.id || 0);
      return !insuranceIds.includes(vid);
    });

    
    const visibleCount = visibleItems.reduce((sum, it) => sum + Number(it.quantity || 0), 0);
    if (els.count) els.count.textContent = String(visibleCount);
    setCountLabel(visibleCount);

    const totalCount = Number(cart?.item_count || 0);
    if (els.headerItemCount) els.headerItemCount.textContent = String(totalCount);

    const subtotalText = formatMoney(cart?.total_price || 0, currency);
    if (els.subtotalMirror) els.subtotalMirror.textContent = subtotalText;

    els.items.innerHTML = (cart.items || [])
      .map((it, idx) => {
        const realLine = idx + 1; 
        const vid = Number(it.id || 0);

       
        if (insuranceIds.includes(vid)) return "";

        const img = it.image
          ? `<img class="cst-item__img" src="${esc(it.image)}" alt="${esc(it.product_title || "")}" loading="lazy">`
          : `<div class="cst-item__img cst-item__img--ph">—</div>`;

        const meta =
          (it.variant_options || []).filter(Boolean).join(" / ") ||
          (it.variant_title && it.variant_title !== "Default Title" ? it.variant_title : "");

        return `
          <div class="cst-item__parent" data-line="${realLine}">
            <div class="cst-item">
              ${img}
              <div class="cst-item__main">
                <div class="cst-item__top">
                  <div class="cst-item__title">${esc(it.product_title || "")}</div>
                  <div class="cst-item__linePrice">${formatMoney(it.final_line_price, currency)}</div>
                </div>

                ${meta ? `<div class="cst-item__meta">${esc(meta)}</div>` : ""}

                <div class="cst-item__actions">
                  <div class="cst-qty">
                    <button type="button" class="cst-qty__btn" data-cst-qty="dec" aria-label="Decrease">−</button>
                    <div class="cst-qty__val" data-cst-qty-val>${Number(it.quantity || 0)}</div>
                    <button type="button" class="cst-qty__btn" data-cst-qty="inc" aria-label="Increase">+</button>
                  </div>

                  <button type="button" class="cst-remove" data-cst-remove>Remove</button>
                </div>
              </div>
            </div>
            ${renderProperties(it.properties)}
          </div>
        `;
      })
      .join("");

    syncInsuranceToggle(cart);
    syncUpsellVisibility(cart);

    const isEmpty = !cart?.items?.length;

    // Empty UI toggle
    if (els.empty) els.empty.hidden = !isEmpty;

    // Hide normal sections when empty
    if (els.sections?.length) {
      els.sections.forEach((sec) => (sec.hidden = isEmpty));
    }

    // Hide pinned + footer when empty
    if (els.pinned) els.pinned.hidden = isEmpty;
    if (els.footer) els.footer.hidden = isEmpty;

    if (isEmpty) {
      if (els.items) els.items.innerHTML = "";
      return;
    }
  };

  const refresh = async ({ openDrawer = false, source = "refresh", requestId = null } = {}) => {

    const cart = await fetchCart();

    const pruned = await pruneInsuranceIfOnlyItemLeft(cart);
      if (pruned) {
        const cart2 = await fetchCart();
        renderCart(cart2);
        if (openDrawer) open();
        window.dispatchEvent(new CustomEvent("cst:cart:updated", { detail: { source, requestId } }));
        return cart2;
      }

    renderCart(cart);
    if (openDrawer) open();

    window.dispatchEvent(new CustomEvent("cst:cart:updated", { detail: { source, requestId } }));
    return cart;
  };

  const ensureAutoAddInsurance = async ({ justAddedVariantId }) => {
    const insId = getInsuranceVariantId();
    if (!insId) return;

    if (Number(justAddedVariantId) === Number(insId)) return;
    if (isInsuranceOptedOut()) return;

    const cart = state.lastCart || (await fetchCart());
    if (cartHasVariant(cart, insId)) return;

    await addViaFormData({ id: insId, quantity: 1, properties: null });
    await refresh({ openDrawer: true });
  };

  /* Drawer click delegation */
  els.drawer.addEventListener("click", (e) => {
    // Upsell pill select (only exists when variants>1)
    const pill = e.target.closest("[data-cst-upsell-pill]");
    if (pill) {
      const card = pill.closest("[data-cst-upsell-card]");
      if (!card) return;

      card.querySelectorAll("[data-cst-upsell-pill]").forEach((b) => {
        b.classList.toggle("is-active", b === pill);
        b.setAttribute("aria-pressed", b === pill ? "true" : "false");
      });

      const variantId = Number(pill.dataset.variantId || 0);
      if (variantId) card.dataset.selectedVariantId = String(variantId);

      const cents = Number(pill.dataset.priceCents || 0);
      const priceEl = card.querySelector("[data-cst-upsell-price]");
      if (priceEl) {
        priceEl.textContent = " for " + formatMoney(cents, state.currency);
      }

      const imgUrl = pill.dataset.img || "";
      const imgEl = card.querySelector("[data-cst-upsell-img]");
      if (imgEl && imgUrl && imgEl.tagName === "IMG") imgEl.src = imgUrl;

      return;
    }

    // Upsell add
    const upsellAdd = e.target.closest("[data-cst-upsell-add]");
    if (upsellAdd) {
      const card = upsellAdd.closest("[data-cst-upsell-card]");
      if (!card || card.hidden) return;

      const variantId = Number(card.dataset.selectedVariantId || 0);
      if (!variantId) return;

      enqueue(async () => {
        setBtnLoading(upsellAdd, true);

        try {
          await addViaFormData({ id: variantId, quantity: 1, properties: null });
          await refresh({ openDrawer: true });
          await ensureAutoAddInsurance({ justAddedVariantId: variantId });
        } catch (err) {
          console.error(err);
        } finally {
          setBtnLoading(upsellAdd, false);
        }
      });

      return;
    }

    // Insurance toggle (pinned)
    const insToggle = e.target.closest("[data-cst-ins-toggle]");
    if (insToggle) {
      const insId = getInsuranceVariantId();
      if (!insId) return;

      enqueue(async () => {
        setBtnLoading(insToggle, true);

        try {
          const cart = state.lastCart || (await fetchCart());
          const has = cartHasVariant(cart, insId);

          if (has) {
            const line = findLineByVariant(cart, insId);
            if (line) await postJson("/cart/change.js", { line, quantity: 0 });
            setInsuranceOptedOut(true);
            await refresh({ openDrawer: true });
          } else {
            await addViaFormData({ id: insId, quantity: 1, properties: null });
            await refresh({ openDrawer: true });
          }
        } catch (err) {
          console.error(err);
        } finally {
          setBtnLoading(insToggle, false);
        }
      });

      return;
    }

    // Cart item actions
    const itemEl = e.target.closest(".cst-item__parent");
    if (!itemEl) return;

    const line = Number(itemEl.getAttribute("data-line") || "0");
    if (!line) return;

    const qtyValEl = itemEl.querySelector("[data-cst-qty-val]");
    const currentQty = Number(qtyValEl?.textContent || "0");

    const qtyBtn = e.target.closest("[data-cst-qty]");
    const rmBtn = e.target.closest("[data-cst-remove]");
    if (!qtyBtn && !rmBtn) return;

    const actionBtn = rmBtn || qtyBtn;

    enqueue(async () => {
      setLineLoading(line, true);
      setBtnLoading(actionBtn, true);

      try {
        const cart = state.lastCart || (await fetchCart());
        const it = cart?.items?.[line - 1];
        const variantId = Number(it?.id || 0);
        const insId = getInsuranceVariantId();

        if (rmBtn) {
          if (insId && variantId === insId) setInsuranceOptedOut(true);
          await postJson("/cart/change.js", { line, quantity: 0 });
          await refresh({ openDrawer: true });
          return;
        }

        if (qtyBtn) {
          const dir = qtyBtn.getAttribute("data-cst-qty");
          const next = dir === "inc" ? currentQty + 1 : Math.max(0, currentQty - 1);

          if (insId && variantId === insId && next === 0) setInsuranceOptedOut(true);

          await postJson("/cart/change.js", { line, quantity: next });
          await refresh({ openDrawer: true });
          return;
        }
      } catch (err) {
        console.error(err);
      } finally {
        setBtnLoading(actionBtn, false);
        setLineLoading(line, false);
      }
    });
  });

  /* Public API */
  const api = {
    open,
    close,
    refresh: () => refresh({ openDrawer: false }),

    add: async ({ id, quantity = 1, properties = null, open: openAfter = true, requestId = null } = {}) => {
      if (!id) throw new Error("Missing id");
      return enqueue(async () => {
        try {
          await addViaFormData({ id, quantity, properties });
          await refresh({ openDrawer: !!openAfter, source: "add", requestId });
          await ensureAutoAddInsurance({ justAddedVariantId: id });
        } catch (err) {
          console.error(err);
          throw err;
        }
      });
    },

    change: ({ line, quantity }) =>
      enqueue(async () => {
        await postJson("/cart/change.js", { line: Number(line), quantity: Number(quantity) });
        await refresh({ openDrawer: true });
      }),

    remove: ({ line }) =>
      enqueue(async () => {
        await postJson("/cart/change.js", { line: Number(line), quantity: 0 });
        await refresh({ openDrawer: true });
      }),
  };

  window.addEventListener("cst:cart:open", () => api.open());
  window.addEventListener("cst:cart:close", () => api.close());
  window.addEventListener("cst:cart:refresh", () => api.refresh());
  window.addEventListener("cst:cart:add", (e) => {
    const d = e?.detail || {};
    api.add({
      id: d.id,
      quantity: d.quantity ?? 1,
      properties: d.properties ?? null,
      open: d.open ?? true,
      requestId: d.requestId ?? null,
    });
  });

  window.CSTDrawer = api;

  refresh({ openDrawer: false }).catch(() => {});
})();